import { render, staticRenderFns } from "./AddLayerPanel.vue?vue&type=template&id=b64b1cf8&scoped=true"
import script from "./AddLayerPanel.vue?vue&type=script&lang=ts"
export * from "./AddLayerPanel.vue?vue&type=script&lang=ts"
import style0 from "./AddLayerPanel.vue?vue&type=style&index=0&id=b64b1cf8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64b1cf8",
  null
  
)

export default component.exports